import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import {
  FiUsers, FiSearch, FiLoader, FiChevronDown, FiChevronUp,
  FiCheck, FiX, FiPhone, FiMail
} from "react-icons/fi";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');

  .mt-root {
    font-family: 'Montserrat', sans-serif;
    padding: 24px;
    max-width: 80rem;
    margin: 0 auto;
    min-height: 100vh;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
  }

  @media (max-width: 640px) {
    .mt-root {
      padding: 16px;
    }
  }

  /* Header */
  .mt-header {
    margin-bottom: 32px;
  }

  .mt-title {
    font-size: 28px;
    font-weight: 700;
    background: linear-gradient(135deg, #1e293b, #475569);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 8px;
  }

  @media (min-width: 640px) {
    .mt-title {
      font-size: 30px;
    }
  }

  .mt-subtitle {
    color: #6b7280;
  }

  /* Summary Cards */
  .mt-summary-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 32px;
  }

  @media (min-width: 768px) {
    .mt-summary-grid {
      grid-template-columns: repeat(5, 1fr);
    }
  }

  @media (max-width: 767px) {
    .mt-summary-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .mt-summary-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    padding: 24px;
    border-left: 4px solid;
  }

  .mt-summary-card-blue {
    border-left-color: #3b82f6;
  }

  .mt-summary-card-green {
    border-left-color: #22c55e;
  }

  .mt-summary-card-purple {
    border-left-color: #8b5cf6;
  }

  .mt-summary-card-orange {
    border-left-color: #f59e0b;
  }

  .mt-summary-card-teal {
    border-left-color: #14b8a6;
  }

  .mt-summary-label {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 4px;
  }

  .mt-summary-value {
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
  }

  /* Level Filter */
  .mt-filter-wrap {
    margin-bottom: 24px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .mt-filter-btn {
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    font-family: 'Montserrat', sans-serif;
  }

  .mt-filter-btn-all {
    background: #3b82f6;
    color: #ffffff;
  }

  .mt-filter-btn-all:hover {
    background: #2563eb;
  }

  .mt-filter-btn-level {
    background: #e5e7eb;
    color: #374151;
  }

  .mt-filter-btn-level:hover {
    background: #d1d5db;
  }

  .mt-filter-btn-active {
    background: #22c55e !important;
    color: #ffffff !important;
  }

  .mt-filter-btn-active:hover {
    background: #16a34a !important;
  }

  .mt-filter-btn-green-active {
    background: #22c55e !important;
    color: #ffffff !important;
  }

  .mt-filter-btn-purple-active {
    background: #8b5cf6 !important;
    color: #ffffff !important;
  }

  .mt-filter-btn-orange-active {
    background: #f59e0b !important;
    color: #ffffff !important;
  }

  /* Search */
  .mt-search-wrap {
    margin-bottom: 24px;
    position: relative;
  }

  .mt-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
  }

  .mt-search-input {
    width: 100%;
    padding: 12px 16px 12px 40px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    transition: all 0.2s;
  }

  .mt-search-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }

  /* Table */
  .mt-table-wrap {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .mt-table-scroll {
    overflow-x: auto;
  }

  .mt-table {
    width: 100%;
    border-collapse: collapse;
  }

  .mt-table-head {
    background: #f9fafb;
  }

  .mt-table-head th {
    padding: 12px 24px;
    text-align: left;
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .mt-table-body {
    border-top: 1px solid #e5e7eb;
  }

  .mt-table-body tr {
    border-bottom: 1px solid #e5e7eb;
    transition: background 0.2s;
  }

  .mt-table-body tr:hover {
    background: #f9fafb;
  }

  .mt-table-body td {
    padding: 16px 24px;
  }

  .mt-empty-row td {
    padding: 48px 24px;
    text-align: center;
    color: #6b7280;
  }

  /* Member Info */
  .mt-member {
    display: flex;
    align-items: center;
  }

  .mt-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 700;
    font-size: 16px;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .mt-member-name {
    font-weight: 500;
    color: #1f2937;
  }

  /* Level Badge */
  .mt-level-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 500;
    background: #dbeafe;
    color: #1e40af;
  }

  /* Status Badges */
  .mt-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 500;
  }

  .mt-badge-active {
    background: #d1fae5;
    color: #065f46;
  }

  .mt-badge-inactive {
    background: #fee2e2;
    color: #991b1b;
  }

  .mt-badge-icon {
    margin-right: 4px;
  }

  /* Program Badges */
  .mt-program-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 500;
    margin-right: 4px;
  }

  .mt-program-lbbp {
    background: #ede9fe;
    color: #5b21b6;
  }

  .mt-program-puap {
    background: #d1fae5;
    color: #065f46;
  }

  .mt-program-group {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }

  /* Expand Button */
  .mt-expand-btn {
    background: none;
    border: none;
    color: #3b82f6;
    cursor: pointer;
    padding: 4px;
    transition: color 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .mt-expand-btn:hover {
    color: #1d4ed8;
  }

  /* Expanded Row */
  .mt-expanded {
    background: #f9fafb;
  }

  .mt-expanded-cell {
    padding: 16px 24px;
  }

  .mt-expanded-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (min-width: 768px) {
    .mt-expanded-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .mt-expanded-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #6b7280;
  }

  .mt-expanded-item svg {
    margin-right: 8px;
    flex-shrink: 0;
  }

  /* Loading State */
  .mt-loading {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
  }

  .mt-loading-content {
    text-align: center;
  }

  .mt-spinner {
    animation: mt-spin 1s linear infinite;
    font-size: 36px;
    color: #3b82f6;
    margin: 0 auto 16px;
    display: block;
  }

  @keyframes mt-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .mt-loading-text {
    color: #6b7280;
  }

  /* Error State */
  .mt-error {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
  }

  .mt-error-content {
    text-align: center;
    color: #ef4444;
  }

  .mt-error-text {
    margin-bottom: 16px;
  }

  .mt-retry-btn {
    padding: 8px 16px;
    background: #3b82f6;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    transition: background 0.2s;
  }

  .mt-retry-btn:hover {
    background: #2563eb;
  }

  /* Responsive */
  @media (max-width: 640px) {
    .mt-table-body td {
      padding: 12px 16px;
    }

    .mt-table-head th {
      padding: 10px 16px;
      font-size: 10px;
    }

    .mt-avatar {
      width: 32px;
      height: 32px;
      font-size: 12px;
      margin-right: 8px;
    }

    .mt-summary-value {
      font-size: 22px;
    }

    .mt-expanded-grid {
      grid-template-columns: 1fr;
    }

    .mt-filter-wrap {
      gap: 4px;
    }

    .mt-filter-btn {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
`;

const MatrixTeam = ({ user }) => {
  const [members, setMembers] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [selectedLevel, setSelectedLevel] = useState("all");

  useEffect(() => {
    fetchMatrixTeam();
  }, []);

  const fetchMatrixTeam = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/puap/matrix-team");
      setMembers(data.members);
      setSummary(data.summary);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to load matrix team");
    } finally {
      setLoading(false);
    }
  };

  const toggleRow = (id) => {
    const set = new Set(expandedRows);
    set.has(id) ? set.delete(id) : set.add(id);
    setExpandedRows(set);
  };

  const getFilteredMembers = () => {
    let filtered = members;
    if (selectedLevel !== "all") {
      const levelNum = parseInt(selectedLevel);
      filtered = members.filter(m => m.level === levelNum);
    }
    
    const q = searchTerm.toLowerCase();
    return filtered.filter(m => {
      return (
        (m.name?.toLowerCase() || "").includes(q) ||
        (m.uniqueId?.toLowerCase() || "").includes(q) ||
        (m.mobile?.toLowerCase() || "").includes(q) ||
        (m.email?.toLowerCase() || "").includes(q)
      );
    });
  };

  const filteredMembers = getFilteredMembers();

  if (loading) {
    return (
      <div className="mt-loading">
        <style>{styles}</style>
        <div className="mt-loading-content">
          <FiLoader className="mt-spinner" />
          <p className="mt-loading-text">Loading matrix team...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mt-error">
        <style>{styles}</style>
        <div className="mt-error-content">
          <p className="mt-error-text">{error}</p>
          <button onClick={fetchMatrixTeam} className="mt-retry-btn">
            Retry
          </button>
        </div>
      </div>
    );
  }

  const getLevelFilterClass = (level) => {
    if (selectedLevel !== level) return "mt-filter-btn-level";
    if (level === "all") return "mt-filter-btn-active";
    if (level === "1") return "mt-filter-btn-green-active";
    if (level === "2") return "mt-filter-btn-purple-active";
    if (level === "3") return "mt-filter-btn-orange-active";
    return "mt-filter-btn-active";
  };

  return (
    <div className="mt-root">
      <style>{styles}</style>

      <div className="mt-header">
        <h1 className="mt-title">Matrix Team</h1>
        <p className="mt-subtitle">View your 3-level matrix team structure</p>
      </div>

      {summary && (
        <div className="mt-summary-grid">
          <div className="mt-summary-card mt-summary-card-blue">
            <div className="mt-summary-label">Total Members</div>
            <div className="mt-summary-value">{summary.totalMembers}</div>
          </div>
          <div className="mt-summary-card mt-summary-card-green">
            <div className="mt-summary-label">Level 1</div>
            <div className="mt-summary-value">{summary.level1Count}</div>
          </div>
          <div className="mt-summary-card mt-summary-card-purple">
            <div className="mt-summary-label">Level 2</div>
            <div className="mt-summary-value">{summary.level2Count}</div>
          </div>
          <div className="mt-summary-card mt-summary-card-orange">
            <div className="mt-summary-label">Level 3</div>
            <div className="mt-summary-value">{summary.level3Count}</div>
          </div>
          <div className="mt-summary-card mt-summary-card-teal">
            <div className="mt-summary-label">PU&AP Active</div>
            <div className="mt-summary-value">{summary.puapActiveMembers}</div>
          </div>
        </div>
      )}

      <div className="mt-filter-wrap">
        <button
          onClick={() => setSelectedLevel("all")}
          className={`mt-filter-btn ${getLevelFilterClass("all")}`}
        >
          All Levels
        </button>
        <button
          onClick={() => setSelectedLevel("1")}
          className={`mt-filter-btn ${getLevelFilterClass("1")}`}
        >
          Level 1 ({summary?.level1Count || 0})
        </button>
        <button
          onClick={() => setSelectedLevel("2")}
          className={`mt-filter-btn ${getLevelFilterClass("2")}`}
        >
          Level 2 ({summary?.level2Count || 0})
        </button>
        <button
          onClick={() => setSelectedLevel("3")}
          className={`mt-filter-btn ${getLevelFilterClass("3")}`}
        >
          Level 3 ({summary?.level3Count || 0})
        </button>
      </div>

      <div className="mt-search-wrap">
        <FiSearch className="mt-search-icon" />
        <input
          type="text"
          placeholder="Search by name, ID, phone, or email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="mt-search-input"
        />
      </div>

      <div className="mt-table-wrap">
        <div className="mt-table-scroll">
          <table className="mt-table">
            <thead className="mt-table-head">
              <tr>
                <th>Member</th>
                <th>ID</th>
                <th>Level</th>
                <th>Status</th>
                <th>Programs</th>
                <th>Join Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="mt-table-body">
              {filteredMembers.length === 0 ? (
                <tr className="mt-empty-row">
                  <td colSpan="7" className="mt-empty-row">
                    No members found
                  </td>
                </tr>
              ) : (
                filteredMembers.map((member) => (
                  <React.Fragment key={member._id}>
                    <tr>
                      <td>
                        <div className="mt-member">
                          <div className="mt-avatar">
                            {member.name?.charAt(0).toUpperCase() || "U"}
                          </div>
                          <div className="mt-member-name">{member.name}</div>
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: '14px', color: '#1f2937' }}>{member.uniqueId}</div>
                      </td>
                      <td>
                        <span className="mt-level-badge">Level {member.level}</span>
                      </td>
                      <td>
                        {member.isActive ? (
                          <span className="mt-badge mt-badge-active">
                            <FiCheck className="mt-badge-icon" size={12} /> Active
                          </span>
                        ) : (
                          <span className="mt-badge mt-badge-inactive">
                            <FiX className="mt-badge-icon" size={12} /> Inactive
                          </span>
                        )}
                      </td>
                      <td>
                        <div className="mt-program-group">
                          {member.isShareActive && (
                            <span className="mt-program-badge mt-program-lbbp">LBBP</span>
                          )}
                          {member.isProductActive && (
                            <span className="mt-program-badge mt-program-puap">PU&AP</span>
                          )}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: '14px', color: '#1f2937' }}>
                          {member.joinDate ? new Date(member.joinDate).toLocaleDateString() : "N/A"}
                        </div>
                      </td>
                      <td>
                        <button
                          onClick={() => toggleRow(member._id)}
                          className="mt-expand-btn"
                        >
                          {expandedRows.has(member._id) ? (
                            <FiChevronUp size={20} />
                          ) : (
                            <FiChevronDown size={20} />
                          )}
                        </button>
                      </td>
                    </tr>
                    {expandedRows.has(member._id) && (
                      <tr className="mt-expanded">
                        <td colSpan="7" className="mt-expanded-cell">
                          <div className="mt-expanded-grid">
                            {member.mobile && (
                              <div className="mt-expanded-item">
                                <FiPhone />
                                {member.mobile}
                              </div>
                            )}
                            {member.email && (
                              <div className="mt-expanded-item">
                                <FiMail />
                                {member.email}
                              </div>
                            )}
                            {member.sponsorId && (
                              <div className="mt-expanded-item">
                                <FiUsers />
                                Sponsor ID: {member.sponsorId}
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MatrixTeam;